import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CertificateApi } from '../api/certificate.api';
import { switchMap, map } from 'rxjs/operators';
import { CertificateData, CertificateMst, PatientCertificate } from '../../../interfaces/patient-services/certificate';

@Injectable()
export class CertificateService extends CertificateData {

  constructor(private api: CertificateApi) {
    super();
  }


  list(url: string): Observable<any[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<CertificateMst>{
      return this.api.getById(url);
  }

  create(url: string, data:any): Observable<CertificateMst> {
    return this.api.add(url,data);
  }

 

  update(url: string, data:CertificateMst): Observable<CertificateMst> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
